import { render, staticRenderFns } from "./combinationTicketDetail.vue?vue&type=template&id=38d2bc7c&scoped=true&"
import script from "./combinationTicketDetail.vue?vue&type=script&lang=js&"
export * from "./combinationTicketDetail.vue?vue&type=script&lang=js&"
import style0 from "./combinationTicketDetail.vue?vue&type=style&index=0&id=38d2bc7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d2bc7c",
  null
  
)

export default component.exports